import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp,
  FaMapMarkerAlt, FaEnvelope, FaGlobe,
  FaArrowRight
} from 'react-icons/fa';
import footerLogo from './images/footer_logo.png';
import './Footer.css';

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Industries', path: '/industries' },
  { label: 'Security', path: '/security' },
  { label: 'Services', path: '/services' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact Us', path: '/contact' },
];

const services = [
  { label: 'Payment Gateway Solutions', id: 'payment-gateway' },
  { label: 'Escrow Payment Systems', id: 'escrow' },
  { label: 'Reconciliation Engine', id: 'reconciliation' },
  { label: 'Finance Applications', id: 'finance-apps' },
  { label: 'Cloud Services', id: 'cloud' },
  { label: 'API Integration', id: 'api-integration' },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-col footer-brand">
              <div className="footer-logo">
                <Link to="/">
                  <img src={footerLogo} alt="Techmascot Technologies" className="footer-logo-img" />
                </Link>
              </div>
              <p className="footer-desc">
                Empowering businesses with cutting-edge fintech solutions. We specialize in
                Payment Gateways, Escrow Systems, Reconciliation Engines, and Cloud Services
                that drive financial innovation.
              </p>
              <div className="footer-social">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link facebook"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link twitter"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link linkedin"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  href="https://wa.me/917903567473"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link whatsapp"
                  aria-label="WhatsApp"
                >
                  <FaWhatsapp />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                {quickLinks.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>
                      <FaArrowRight className="link-arrow" />
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="footer-col">
              <h4 className="footer-title">Our Services</h4>
              <ul className="footer-links">
                {services.map((s) => (
                  <li key={s.id}>
                    <Link to={`/services?service=${s.id}`}>
                      <FaArrowRight className="link-arrow" />
                      {s.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-col">
              <h4 className="footer-title">Contact Us</h4>
              <ul className="footer-contact-list">
                <li>
                  <FaEnvelope className="contact-icon" />
                  <a href="mailto:info@techmascot.in">info@techmascot.in</a>
                </li>
                <li>
                  <FaGlobe className="contact-icon" />
                  <a href="https://www.techmascot.in" target="_blank" rel="noopener noreferrer">
                    www.techmascot.in
                  </a>
                </li>
                <li>
                  <FaWhatsapp className="contact-icon" />
                  <a href="https://wa.me/917903567473" target="_blank" rel="noopener noreferrer">
                    WhatsApp Us
                  </a>
                </li>
                <li>
                  <FaMapMarkerAlt className="contact-icon" />
                  <span>India</span>
                </li>
              </ul>

              <div className="footer-newsletter">
                <p>Stay updated with our latest solutions</p>
                <div className="newsletter-form">
                  <input type="email" placeholder="Your email address" />
                  <button type="button">Subscribe</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-inner">
            <p>
              &copy; {currentYear} <strong>Techmascot Technologies Private Limited</strong>. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
              <Link to="/cookie-policy">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
